import React from "react";
import { observer } from "mobx-react";
import Button from "Components/common/Button";
import { openAddLinkedInAccountPopup } from "./common/addLinkedInAccountTrigger";

// Account type (standard vs. Sales Navigator) and connect method (extension
// vs. LinkedIn login) are both chosen inside the popup now, so this is a
// single button rather than the old "LinkedIn / Sales Navigator" dropdown.
const ConnectedLinkedInButton = observer((props = {}) => {
  return (
    <div className="dropdownBtn">
      <Button
        id="ConnectedLinkedInButton"
        name="ConnectedLinkedInButton"
        btnText="Connect Account"
        type="button"
        className={`ConnectedLinkedInButton`}
        click={openAddLinkedInAccountPopup}
      />
    </div>
  );
});

export { ConnectedLinkedInButton };
export default ConnectedLinkedInButton;
